import { combineReducers } from "redux";

import appointmentsReducer from "./appointmentsReducer";
// import machinesReducer from "./machinesReducer";
import patientsReducer from "./patientsReducer";
import refDoctorsReducer from "./refDoctorsReducer";
import visitsReducer from "./visitsReducer";
import visitsRoaster from "./visitsRoasterReducer";
import examCodesReducer from "./examCodesReducer";
import radiologistsReducer from "./radiologistsReducer";
import techniciansReducer from "./techniciansReducer";
import worklistReducer from "./worklistReducer";
import quickCodesReducer from "./quickCodesReducer";
import pendingVisitor from "./pendingVisitorsReducer";
import { organisationsReducer } from "./organisationsReducer"
import { accountsReducer } from "./accountsReducer"


const receptionistReducer = combineReducers({
    appointments: appointmentsReducer,
    visits: visitsReducer,
    patients: patientsReducer,
    visitsRoaster: visitsRoaster,
    pendingVisitor: pendingVisitor,
    refDoctors: refDoctorsReducer,
    // machines: machinesReducer,
    examCodes: examCodesReducer,
    radiologists: radiologistsReducer,
    technicians: techniciansReducer,
    worklist: worklistReducer,
    quickcodes: quickCodesReducer,
    organisations: organisationsReducer,
    accounts: accountsReducer,
});

export default receptionistReducer;
